import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import images from '../../assets/images';
import { INTERESTS_MODAL } from '../../context/general/constants';
import { useGeneralDispatch, useGeneralState } from '../../context/general/generalContext';
import { useRequest } from '../../hooks/useRequest';
import InterestImgCheckbox from '../elements/InterestImgCheckbox';

export const InterestsModalWithImg = () => {
  const dispatch = useGeneralDispatch();
  const { interestsModal } = useGeneralState();
  const [allInterests, setAllInterests] = useState([]);

  const { request } = useRequest();
  useEffect(() => {
    request('post/getAreaOfInterest')
      .then((res) => {
        if (interestsModal.isFirstLogin) {
          setAllInterests(
            res.data.result.map((r) => {
              return { ...r, checked: false };
            })
          );
        } else {
          setAllInterests(
            res.data.result.map((r) => {
              if (interestsModal.detail.filter((i) => i.id == r.id).length > 0) {
                return { ...r, checked: true };
              } else {
                return { ...r, checked: false };
              }
            })
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const closeModal = () => {
    dispatch({
      type: INTERESTS_MODAL,
      payload: { open: false, isFirstLogin: false, detail: '' }
    });
  };

  const handleChekckboxChange = (e, item) => {
    setAllInterests([
      ...allInterests.map((i) => {
        if (i.id == item.id) {
          return { ...i, checked: e.target.checked };
        } else {
          return i;
        }
      })
    ]);
  };
  const handleSubmit = () => {
    request('post/setAreaOfInterest', {
      method: 'POST',
      body: {
        ids: allInterests.filter((i) => i.checked).map((i) => i.id)
      }
    }).then((res) => {
      if (res.data.ok) {
        closeModal();
        toast.success(res.data.metadata.message);
      }
    });
  };
  return (
    <div className="interests-modal">
      <div className="interests-modal--content">
        <img
          onClick={closeModal}
          className="interests-modal--content--close"
          src={images.iconClose}
          alt="Close Icon"
          data-modal-close="data-modal-close"
        />
        <div className="interests">
          {interestsModal.isFirstLogin ? (
            <h1 className="interests--welcome--title">Hoş geldin 😊</h1>
          ) : (
            ''
          )}
          <div className="interests--welcome--text">
            Seçimlerinize göre ilgini çekecek seçenekleri öne çıkaralım ve bildirim gönderelim
          </div>
          <div className="interests--container">
            <div className="interests--container--list">
              {allInterests &&
                allInterests.map((item) => (
                  <InterestImgCheckbox
                    handleCheckbox={handleChekckboxChange}
                    key={item.id}
                    interest={item}
                  />
                ))}
            </div>
            <div className="interests--container--buttons">
              {allInterests?.filter((i) => i.checked).length > 0 && (
                <div className="interests--container--buttons--button">
                  <button className="default-green-button" onClick={handleSubmit}>
                    {interestsModal.isFirstLogin ? 'Devam' : 'Kaydet'}
                  </button>
                </div>
              )}
              {interestsModal.isFirstLogin && (
                <div className="interests--container--buttons--button">
                  <button className="default-underline-button" onClick={closeModal}>
                    Atla
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
